/**
 * Portal footer — version string + accessibility link + copyright.
 * Version is right-aligned mono per global CLAUDE.md rule.
 */

import { PORTAL_NAME, PORTAL_VERSION } from '../../constants/version';

export function Footer(): JSX.Element {
  const year = new Date().getFullYear();
  return (
    <footer className="pcb-footer">
      <div>
        &copy; {year} Phelps County Bank. Member FDIC. Equal Housing Lender.{' '}
        <a href="/accessibility">Accessibility statement</a>
      </div>
      <div className="pcb-footer-version" aria-label={`${PORTAL_NAME} version ${PORTAL_VERSION}`}>
        {PORTAL_NAME} &middot; v{PORTAL_VERSION}
      </div>
    </footer>
  );
}
